import React from "react";
import "../style/landing.css";

const Landing = () => {
  return (
    <div className="landing">
      <h1 data-aos="fade-up" className="landing-heading-top">
        Hola,
      </h1>
      <h1 data-aos="fade-up" className="landing-heading">
        Soy <span>Vikas</span>
      </h1>
      <h2 data-aos="fade-up" className="landing-texto">
        Desarrollador web
      </h2>
      <h2 data-aos="fade-up" className="landing-texto">
        Front-End y Back-End
      </h2>
      <h2 data-aos="fade-up" className="landing-texto">
        Diseño de páginas web.
      </h2>
      <a
        data-aos="fade-up"
        target="blank"
        href="/assets/full_stack_developer_vikas.pdf"
        download
      >
        <button className="btn-active">CURRÍCULUM</button>
      </a>
    </div>
  );
};

export default Landing;
